import { customerById } from 'api/core'
import { searchSaleOrderId } from 'api/documentBus'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { isWebDocumentOrigin } from 'Utils/isWebDocumentOrigin'

export const useBusLogic = () => {
  const orderDispatchPostData = useSelector(
    state => state.sellOrder.orderDispatchPostData?.Data
  )

  const isWebDocument = isWebDocumentOrigin(
    orderDispatchPostData?.SalesDocumentInfo?.OriginODV
  )
  const odvDocHeaderId =
    orderDispatchPostData?.SalesDocumentInfo?.SalesOrderHeaderId

  const [currentSelectedAddress, setCurrentSelectedAddress] = useState({})

  useEffect(() => {
    const getOdvDetails = async saleOrderId => {
      try {
        const data = await searchSaleOrderId({
          saleOrderId: odvDocHeaderId,
        })
        const customerId = orderDispatchPostData?.SalesDocumentInfo?.CustomerId
        const busAddressId = data?.Data?.[0]?.AddressId?.toLowerCase()
        const userData = await customerById(customerId)
        const addressData = userData?.data?.Data?.AddressList
        const selectedAddressData = addressData?.find(
          address =>
            address?.AddressInfo?.AddressId?.toLowerCase() === busAddressId
        )?.AddressInfo
        if (selectedAddressData) {
          setCurrentSelectedAddress(selectedAddressData)
        }
      } catch (error) {
        console.error('Error:', error)
      }
    }
    if (isWebDocument && odvDocHeaderId) {
      getOdvDetails(odvDocHeaderId)
    }
  }, [odvDocHeaderId])
  return { currentSelectedAddress, isWebDocument }
}
